import React, { useState } from 'react';

const ContactModal = ({ close }) => {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = e => {
    e.preventDefault();
    // TODO: send { subject, message } to your support endpoint
    alert(`Sent!\nSubject: ${subject}\nMessage: ${message}`);
    close();
  };

  return (
    <div className="modal-overlay" onClick={close}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={close}>×</button>
        <h2>Contact Support</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            required
            placeholder="Subject"
            value={subject}
            onChange={e => setSubject(e.target.value)}
          />
          <textarea
            required
            rows="5"
            placeholder="Describe your question or issue..."
            value={message}
            onChange={e => setMessage(e.target.value)}
          />
          <button type="submit" className="btn-primary">Send</button>
        </form>
      </div>
    </div>
  );
};

export default ContactModal;
